import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { apiRequest } from "../api";
import { SiteRenderer, type PublicSiteData } from "../components/SiteRenderer";
import { siteResolveQuery, useSiteSlug } from "../site-context";

export function PublicSitePage() {
  const { slug: paramSlug = "" } = useParams();
  const slug = useSiteSlug(paramSlug);
  const [search] = useSearchParams();
  const preview =
    search.get("preview") === "1" || search.get("preview") === "true";
  const [site, setSite] = useState<PublicSiteData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const qs = siteResolveQuery(slug, preview);
    if (!qs.includes("slug=") && !qs.includes("host=")) return;
    void apiRequest<{ site: PublicSiteData }>(`/sites/resolve?${qs}`)
      .then((data) => {
        setSite(data.site);
        if (data.site.website.seoTitle)
          document.title = data.site.website.seoTitle;
      })
      .catch((err: Error) => setError(err.message));
  }, [slug, preview]);

  if (error) {
    return (
      <main className="auth-layout">
        <div className="auth-card">
          <h1>Website unavailable</h1>
          <p className="notice error">{error}</p>
        </div>
      </main>
    );
  }

  if (!site) {
    return (
      <main className="auth-layout">
        <p className="notice" style={{ color: "#ecfdf5" }}>
          Loading website...
        </p>
      </main>
    );
  }

  return <SiteRenderer site={site} slug={slug} />;
}
